import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { logEvent, analytics } from '../firebase.js';
import { isNativeApp } from '../services/platform-service.js';
import { storeUrlForDevice, isInstalledPWA } from '../services/app-links.js';

// `/create` 의 마지막 방어선.
//
// 게이트를 버튼마다 걸면 버튼이 하나 늘 때마다 구멍이 하나 는다. 실제로
// 그랬다 — `AppGateModal` 에서 "웹에서 계속" 을 뺐는데도 Landing 의
// "웹에서 계속하기 →" 와 ShareView 의 "Create with archelier" 두 개가
// 게이트를 안 거치고 `/create` 로 바로 들어가고 있었다. 그래서 버튼이 아니라
// **만드는 화면 자체**를 라우트에서 막는다. DesignDetail·MyDesigns·탭바·
// 뒤로가기 fallback 까지 여기 한 곳에서 닫힌다.
//
// 막는 대상은 **모바일 웹뿐**이다 (`useAppGate` 와 같은 기준):
// - 네이티브 앱은 여기가 홈이다.
// - 데스크톱은 스토어로 보내도 설치할 기기가 없다 (생성/사용자 0.59 로
//   모바일 웹의 0.23 보다 잘 쓴다 — 막으면 순손실).
// - 홈 화면에 설치한 PWA 도 통과시킨다. 이미 설치한 사람을 스토어로 내모는
//   건 게이트가 아니라 앱을 뺏는 것이다.
//
// 보내는 곳은 `/landing` 이다. 스토어 버튼과 앱 소개가 거기 다 있다.
// 시트를 씌우지 않는 이유는, 시트 뒤에 보여줄 "보던 화면" 이 없기 때문이다 —
// 공유 링크처럼 읽던 맥락이 있는 자리는 그쪽에서 `useAppGate` 가 맡는다.
export function RequireApp({ children }) {
  const blocked = !isNativeApp() && !isInstalledPWA() && !!storeUrlForDevice();

  useEffect(() => {
    if (blocked) logEvent(analytics, 'app_gate_shown', { surface: 'create_route', action: 'open_create' });
  }, [blocked]);

  if (blocked) return <Navigate to="/landing" replace />;
  return children;
}
